import useSalon from '@admin/models/Salon'
import { resources } from '@api'
import { notify, route } from '@helpers'
import useTitle from '@hooks/useTitle'
import MainContainer from '@blocks/MainContainer'
import React from 'react'
import { useHistory } from 'react-router-dom'
import SalonForm from '../Form'
import SalonEditHeading from './components/SalonEditHeading'

export default function SalonEdit({ id }: Props) {
    const history = useHistory()
    const salon = useSalon(id)
    useTitle("Edit: " + salon.attrs.name())

    if (!salon.state)
        return null

    const handleSuccess = () => {
        notify("Thanks, the salon was updated!")
        history.push(route("admin:salon", id))
    }

    return (
        <MainContainer heading={<SalonEditHeading salon={salon.state} />}>
            <SalonForm 
                salon={salon.state}
                method="patch"
                url={`${resources.salons}/${id}`}
                handleSuccess={handleSuccess} />
        </MainContainer>
    )
}

interface Props {
    id: number | string
}